import * as echarts from 'echarts';
import { EleResize } from './a.js'
import zhanjiangMP from "@/assets/get/china.json"
const randomColor = require('randomcolor');
import i18n from "@/i18n";
// import zhanjiangMP from "@/assets/get/china.json"
const deviceBindingStatisticsEcharts = (options) => {
    let { chartDom } = options;
    let myChart = chartDom && echarts.init(chartDom, null, { renderer: 'svg' });
    let option = {
        title: {
            show: false
        },
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(60, 66, 84, 0.70)',
            borderWidth: 0,
            textStyle: {
                color: '#FFFFFF'
            }
        },
        legend: {
            left: 'center',
            top: 0,
            icon: 'circle',
            itemWidth: 8,
            itemHeight: 8,
            itemGap: 37,
            textStyle: {
                fontSize: 12,
                fontFamily: 'Microsoft YaHei',
                fontWeight: 'normal',
                color: '#82DAF7'
            }
        },
        grid: {
            x: '5%',
            y: '15%',
            x2: '5%',
            y2: '15%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            axisTick: {
                show: false
            },
            axisLabel: {
                interval: 0,
                textStyle: {
                    fontSize: 12,
                    fontFamily: 'Alibaba PuHuiTi',
                    fontWeight: 400,
                    color: '#B6B7BC',
                    padding: [5, 0, 0, 0]
                }
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#294462',
                    opacity: 0.3,
                    type: 'dotted'
                }
            },
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
        },
        yAxis: {
            type: 'value',
            minInterval: 5,
            name: '',
            nameTextStyle: {
                fontSize: 18,
                fontFamily: 'CenturyGothic',
                color: '#ffffff',
                padding: [0, 0, 0, 30]
            },
            axisTick: {
                show: false
            },
            axisLine: {
                show: false
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#B6B7BC33',
                    type: 'dashed',
                }
            },
            axisLabel: {
                textStyle: {
                    fontSize: 12,
                    fontFamily: 'CenturyGothic',
                    fontWeight: 'normal',
                    color: '#FFFFFF',
                    padding: [0, 5, 0, 0]
                }
            }
        },

        series: [{
            name: '图例1',
            type: 'bar',
            barWidth: 10,
            itemStyle: {
                color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                        offset: 0, color: '#11CABE' // 0% 处的颜色
                    }, {
                        offset: 1, color: '#11CABE' // 100% 处的颜色
                    }]
                }
            },
            data: [87, 60, 124, 20, 432, 124, 20, 432, 124, 20, 432, 432]
        }, {
            name: '图例2',
            type: 'bar',
            barWidth: 10,
            itemStyle: {
                borderWidth: 1,
                color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                        offset: 0, color: '#246CF9' // 0% 处的颜色
                    }, {
                        offset: 1, color: '#246CF9' // 100% 处的颜色
                    }]
                }
            },
            data: [90, 66, 174, 100, 430, 66, 174, 100, 430, 66, 174, 100]
        }]
    };
    var listener = () => {
        myChart.resize()
    }
    EleResize.on(chartDom, listener)
    myChart.clear()
    myChart && option && myChart.setOption(option)
}
const deviceStatusEcharts = (options) => {
    let { chartDom } = options;
    let myChart = chartDom && echarts.init(chartDom, null, { renderer: 'svg' });
    let option = {
        title: {
            show: false
        },
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(60, 66, 84, 0.70)',
            borderWidth: 0,
            textStyle: {
                color: '#FFFFFF'
            }
        },
        legend: {
            show: false,
            left: 'center',
            top: 0,
            icon: 'circle',
            itemWidth: 8,
            itemHeight: 8,
            itemGap: 37,
            textStyle: {
                fontSize: 12,
                fontFamily: 'Microsoft YaHei',
                fontWeight: 'normal',
                color: '#82DAF7'
            }
        },
        grid: {
            x: '5%',
            y: '5%',
            x2: '5%',
            y2: '5%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            axisTick: {
                show: false
            },
            axisLabel: {
                interval: 0,
                textStyle: {
                    fontSize: 12,
                    fontFamily: 'Alibaba PuHuiTi',
                    fontWeight: 400,
                    color: '#B6B7BC',
                    padding: [5, 0, 0, 0]
                }
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#294462',
                    opacity: 0.3,
                    type: 'dotted'
                }
            },
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
        },
        yAxis: {
            type: 'value',
            minInterval: 5,
            name: '',
            nameTextStyle: {
                fontSize: 18,
                fontFamily: 'CenturyGothic',
                color: '#ffffff',
                padding: [0, 0, 0, 30]
            },
            axisTick: {
                show: false
            },
            axisLine: {
                show: false
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#B6B7BC33',
                    type: 'dashed',
                }
            },
            axisLabel: {
                textStyle: {
                    fontSize: 12,
                    fontFamily: 'CenturyGothic',
                    fontWeight: 'normal',
                    color: '#B6B7BC',
                    padding: [0, 5, 0, 0]
                }
            }
        },

        series: [{
            name: '图例1',
            type: 'bar',
            barWidth: 20,
            itemStyle: {
                color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                        offset: 0, color: '#11CABE' // 0% 处的颜色
                    }, {
                        offset: 1, color: '#11CABE' // 100% 处的颜色
                    }]
                }
            },
            data: [87, 60, 124, 20, 432, 124, 20, 432, 124, 20, 432, 432]
        }]
    };
    var listener = () => {
        myChart.resize()
    }
    EleResize.on(chartDom, listener)
    myChart.clear()
    myChart && option && myChart.setOption(option)
}
const deviceTypeStatisticsEcharts = (options,callback) => {
    const colorBlue = {root: "#246CF9",sub: ['#042E80', '#07348C', '#0A3A98', '#0E41A4', '#1147B0', '#1753C9', '#1E60E1', '#246CF9', '#4280FA', '#6094FB', '#7DA8FB', '#8CB2FC', '#9BBCFC', '#AAC6FD', '#B9D0FD']}
    const colorGreen = {root: "#11CABE",sub: ['#09645E', '#0A726C', '#0C9087', '#0FADA3', '#07504B', '#085C57', '#096862', '#0A756E', '#0B8179', '#0D9990', '#0FB2A7', '#11CABE', '#23D2C7', '#36DAD0', '#48E3D8', '#51E7DD', '#5BEBE1', '#64EFE6', '#6DF3EA']}
    const colorBlueGreen = {root: "#14ACC1",sub: ['#14ACC1', '#25B6CA', '#36C0D4', '#48CBDD', '#50D0E2', '#59D5E7', '#61DAEB', '#6ADFF0']}
    const colorPurple = {root: "#8371F2",sub: ['#462BEC', '#4C32ED', '#5239ED', '#5840EE', '#5E47EE', '#6B55F0', '#7763F1', '#8371F2', '#8F7FF3', '#9B8DF4', '#A89BF6', '#AEA2F6', '#B4A9F7', '#BAB0F7', '#C0B7F8']}

    let { chartDom ,dataList,unit,unit2 } = options;
    let myChart = chartDom && echarts.init(chartDom, null, { renderer: 'svg' });
    var data = dataList

    let count = 0

    function _sort(x, y) {
        if (x.value > y.value) {
            return -1;
        }
        if (x.value < y.value) {
            return 1;
        }
        return 0;
    }
    
    dataList.forEach((data) => {
        count += data.value
        if (data.name == '风机') {
          data.itemStyle = {
            color: colorBlue.root
          }
          if (data.children && data.children.length > 0) {
            data.children.sort(_sort)

            let i = 0
            data.children.forEach(child => {
              if (i == colorBlue.sub.length) {
                i = 0
              }
              child.itemStyle = {
                color: colorBlue.sub[i]
              }
              i++
              if (child.children && child.children.length > 0) {
                child.children.sort(_sort)
                child.children.forEach(_child => {
                    _child.itemStyle = {
                      color: randomColor()
                    }
                })
              }
            })
          }
        } else if (data.name == '罗茨泵') {
          data.itemStyle = {
            color: colorBlueGreen.root
          }
          if (data.children && data.children.length > 0) {
            data.children.sort(_sort)

            let i = 0
            data.children.forEach(child => {
              if (i == colorBlueGreen.sub.length) {
                i = 0
              }
              child.itemStyle = {
                color: colorBlueGreen.sub[i]
              }
              i++
              if (child.children && child.children.length > 0) {
                child.children.sort(_sort)
                child.children.forEach(_child => {
                    _child.itemStyle = {
                      color: randomColor()
                    }
                })
              }
            })
          }
        } else if (data.name == '液环泵') {
          data.itemStyle = {
            color: colorGreen.root
          }
          if (data.children && data.children.length > 0) {
            data.children.sort(_sort)

            let i = 0
            data.children.forEach(child => {
              if (i == colorGreen.sub.length) {
                i = 0
              }
              child.itemStyle = {
                color: colorGreen.sub[i]
              }
              i++
              if (child.children && child.children.length > 0) {
                child.children.sort(_sort)
                child.children.forEach(_child => {
                    _child.itemStyle = {
                      color: randomColor()
                    }
                })
              }
            })
          }
        } else if (data.name == '干泵') {
          data.itemStyle = {
            color: colorPurple.root
          }
          if (data.children && data.children.length > 0) {
            data.children.sort(_sort)

            let i = 0
            data.children.forEach(child => {
              if (i == colorPurple.sub.length) {
                i = 0
              }
              child.itemStyle = {
                color: colorPurple.sub[i]
              }
              i++
              if (child.children && child.children.length > 0) {
                child.children.sort(_sort)
                child.children.forEach(_child => {
                    _child.itemStyle = {
                      color: randomColor()
                    }
                })
              }
            })
          }
        }
    })

    let option = {
        title: {
          text: unit+'\n' + count + unit2,
          left: 'center',
          top: 'center',
          textStyle: { color: '#FFF',fontSize:12 }
        },
        tooltip: {
            show: true
        },
        series: {
            type: 'sunburst',
            nodeClick: 'rootToNode',
            data: data,
            radius: ['0%', '95%'],
            center: ['50%', '50%'],
            startAngle:180,
            sort: undefined,
            // color:["#B9D0FD","#AAC6FD","#9BBCFC","#8CB2FC","#7DA8FB","#6094FB","#4280FA","#246CF9","#1E60E1","#1753C9","#1147B0","#0E41A4","#0A3A98","#07348C","#042E80","#6DF3EA","#64EFE6","#5BEBE1","#51E7DD","#48E3D8","#36DAD0","#23D2C7","#11CABE","#0FB2A7","#0D9990","#0B8179","#0A756E","#096862","#085C57","#07504B","#0FADA3","#0C9087","#0A726C","#09645E","#075550","#064743","#053835","#6ADFF0","#61DAEB","#59D5E7","#50D0E2","#48CBDD","#36C0D4","#25B6CA","#14ACC1","#C0B7F8","#BAB0F7","#B4A9F7","#AEA2F6","#A89BF6","#9B8DF4","#8F7FF3","#8371F2","#7763F1","#6B55F0","#5E47EE","#5840EE","#5239ED","#4C32ED","#462BEC"],
            emphasis: {
                focus: 'ancestor',
            },
            labelLayout: {
              hideOverlap: true
            },
            tooltip: {
                formatter: (e) => {
                    console.log(e)
                    if (e.data.name) {
                        
                        return e.data.name+':'+e.data.value
                    } else {
                        return ''
                    }
              }
            },
            levels: [
                {},
                {
                    r0:'25%',
                    r: '40%',
                    itemStyle: {
                        borderWidth: 0,
                    },
                    label: {
                        rotate: 'tangential',
                        fontSize: 12,
                        fontWeight: 600,
                        color: '#ffffff'
                    },
                },
                {
                    r0: '40%',
                    r: '65%',
                    itemStyle: {
                        borderWidth: 0,
                    },
                    label: {
                        align: 'center',
                        fontSize: 12,
                        fontWeight: 600,
                        color: '#ffffff'

                    },
                },
                {
                    r0: '65%',
                    r: '70%',
                    label: {
                        position: 'outside',
                        padding: 3,
                        fontSize: 12,
                        fontWeight: 400,
                        color: '#ffffff'
                    },
                    itemStyle: {
                        borderWidth: 0,
                    },
                },
            ],
        },
    };
    var timeFn = null;

    //单击切换到省级地图，当mapCode有值,说明可以切换到下级地图
    myChart.on('click', function (params) {
        console.log(params)
        clearTimeout(timeFn);
        //由于单击事件和双击事件冲突，故单击的响应事件延迟250毫秒执行
        timeFn = setTimeout(function () {
                callback(params)
            }, 250);
      
    });
    var listener = () => {
        myChart.resize()
    }
    EleResize.on(chartDom, listener)
    console.log("deviceTypeStatisticsEcharts", JSON.stringify(option))
    myChart.clear()
    myChart && option && myChart.setOption(option)
}
const industryStatisticsBarEcharts = (options) => {
    let { chartDom,dataList,nameList,language } = options;
    let myChart = chartDom && echarts.init(chartDom, null, { renderer: 'svg' });
    var normalColor = "rgba(255,255,255,.5)";


    let option = {
        color: ['#0A938A', '#11CABE', '#14ACC1', '#8371F2', '#246CF9'],
        legend: {
            itemGap: 15,
            icon: 'circle',
            itemWidth: 8, // 设置宽度
            itemHeight: 8,
            top: '0',
            left: 'center',
            textStyle: {
                color: '#ffffff'
            }
        },
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(60, 66, 84, 0.70)',
            borderWidth: 0,
            textStyle: {
                color: '#FFFFFF'
            }
        },
        grid: {
            left: '5%',
            right: '5%',
            bottom: '5%',
            top: '15%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'category',
                

                axisLabel: {
                  interval:0,
                    rotate: language == 'en' ? 0 : 0,
                  fontSize: language == 'en' ? 11 : 12,
                  formatter:function(value)
                                            {
                                                return language=='en'?value.split(" ").join("\n"):value;
                                            }
                },
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: false,
                    lineStyle: {
                        color: normalColor,
                    }
                },
                splitLine: {
                    show: false,
                    lineStyle: {
                        type: "solid",
                        color: normalColor
                    }
                },
                data: nameList
            }
        ],
        yAxis: [
            {
                type: 'value',
                axisLabel: {
                    formatter: function (params) {
                        return params;
                    }
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: '#B6B7BC33',
                        type: 'dashed',
                    }
                },
            }
        ],
        series:dataList
    };
    var listener = () => {
        myChart.resize()
    }
    EleResize.on(chartDom, listener)
    myChart.clear()
    myChart && option && myChart.setOption(option)
}
const industryStatisticsEcharts = (options) => {
    let { chartDom, dataList } = options;
    let myChart = chartDom && echarts.init(chartDom, null, { renderer: 'svg' });
    let resultData = {
        status: 'success',
        data: dataList,
        msg: 'exercitation in',
    };

    //  颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
    let colorList = [
        new echarts.graphic.RadialGradient(0.5, 0.2, 0.8, [
            {
                offset: 0,
                color: '#87BEF9',
            },
            {
                offset: 0.5,
                color: '#246CF9',
            },
            {
                offset: 1,
                color: '#2F3955',
            },
        ]),
        new echarts.graphic.RadialGradient(0.5, 0.2, 0.8, [
            {
                offset: 0,
                color: '#9FF2F8',
            },
            {
                offset: 0.5,
                color: '#11CABE',
            },
            {
                offset: 1,
                color: '#2F3955',
            },
        ]),
        new echarts.graphic.RadialGradient(0.5, 0.2, 0.8, [
            {
                offset: 0,
                color: '#797979',
            },
            {
                offset: 0.5,
                color: '#282C38',
            },
            {
                offset: 1,
                color: '#2F3955',
            },
        ]),

    ];
    let colorsList = ['#246CF9', '#11CABE', '#282C38']
    // 生成随机坐标的不重叠圆
    function drawCircles(maxLength, radius, max_x, max_y) {
        let circles = [];
        let anti_crash_count = 0;
        while (circles.length < maxLength) {
            let circle = {
                x: getRandomNumber(radius, max_x - radius),
                y: getRandomNumber(radius, max_y - radius),
                radius,
            };

            let isOverlapping = false;

            for (let j = 0; j < circles.length; j++) {
                let previous_circle = circles[j];
                let distance = Math.hypot(circle.x - previous_circle.x, circle.y - previous_circle.y);

                if (distance < circle.radius + previous_circle.radius) {
                    isOverlapping = true;
                    break;
                }
            }

            if (!isOverlapping) {
                circles.push(circle);
            }
            anti_crash_count++;
            if (anti_crash_count > 10000) {
                break;
            }
        }
        return circles;
    }

    // 生成随机数坐标
    function getRandomNumber(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
    }
    // 数据数组
    let countList = resultData.data;
    var max = 0;
    countList.forEach((e, i) => {
        e.id = i;
        e.label = {
            normal: {
                show: false,
                color: '#fff',
            },
        };
        e.itemStyle = {
            normal: {
                color: e.value < 100 ? colorList[2] : (e.value > 200 ? colorList[0] : colorList[1]),
                opacity: 1,
                borderWidth: 1,
                borderColor: e.value < 100 ? colorList[2] : (e.value > 200 ? colorList[0] : colorList[1]),
                shadowBlur: 20,
                symbolOffset: 10,
                shadowColor: e.value < 100 ? colorsList[2] : (e.value > 200 ? colorsList[0] : colorsList[1]),
            },
        };
        if (e.value >= max) max = e.value;
    });
    // 放大规则
    var number = Math.round(max * 0.2);
    let graphCanvas = document.getElementById('industryStatistics');
    var domLocal
    graphCanvas && (domLocal = graphCanvas.getBoundingClientRect());
    console.log(domLocal)
    let randomCircleArr = drawCircles(
        countList.length,
        ((max + number) / max) * 40,
        domLocal.width,
        domLocal.height
    );
    countList.forEach((e, i) => {
        if (randomCircleArr[i]) {
            e.x = randomCircleArr[i].x;
            e.y = randomCircleArr[i].y;
            e.symbolSize = ((e.value + number) / max) * 80;
            e.label.normal.fontSize = ((e.value + number) / max) * 15;
        } else {
            e.symbolSize = 0;
            e.x = 0;
            e.y = 0;
        }
        e.label = {
            normal: {
                show: e.symbolSize > 50 ? true : false,
                color: '#fff',
            },
        };
    });
    console.log(countList)
    var list1 = []
    var list2 = []
    var list3 = []
    countList.map(item => {
        if (item.value >= 200) {
            list1.push(item)
        }
        if (item.value > 100 && item.value < 200) {
            list2.push(item)
        }
        if (item.value <= 100) {
            list3.push(item)
        }
    })
    let option = {
        title: {},
        legend: {
            itemGap: 15,
            icon: 'circle',
            itemWidth: 20, // 设置宽度
            itemHeight: 20,
            bottom: '0',
            left: 'center',
            textStyle: {
                color: '#ffffff'
            },
            data: [i18n.global.t("['大于200台']"), i18n.global.t("['100～200台']"), i18n.global.t("['小于100台']")]
        },
        color:colorsList,
        tooltip: {
            trigger: 'item',
            formatter: function (params) {
                console.log(params)
                if (params['data']['name'] !== '') {
                    return '<b>' + params['data']['name']+'('+ params['data']['product']+')' + '</b>：<b>' + params['data']['value'] + ' </b>';
                }
            },
            backgroundColor: 'rgba(60, 66, 84, 0.70)',
            borderWidth: 0,
            textStyle: {
                color: '#FFFFFF'
            }
        },
        grid: {
            left: 0,
            right: 0,
            top: 0,
            bottom: '5%',
        },
        series: [
            {
                name:i18n.global.t("['大于200台']"),
                type: 'graph',
                layout: 'none',
                force: {
                    repulsion: 2500,
                    edgeLength: [10, 50]
                },
                label: {
                    show: true,
                    verticalAlign: 'middle',
                    align: 'center',
                    formatter: (val) => {
                        console.log(val)
                        return  [
                            val.data.product,
                            val.name,
                            val.value,
                        ].join('\n')
                    },
                    rich: {
                        a: {
                            fontSize: 12,
                            fontWeight: 400,
                            color: '#FFFFFF',
                        }, b: {
                            fontSize: 16,
                            fontWeight: 400,
                            color: '#FFFFFF',
                        }, c: {
                            fontSize: 12,
                            fontWeight: 400,
                            color: '#FFFFFF',
                        }
                    }
                },
                data: list1,
                animation: true,
                animationThreshold: 2000,
                animationDuration: 1000,
                animationEasing: 'cubicOut',
                animationDelay: 0,
                animationDurationUpdate: 300,
                animationEasingUpdate: 'cubicInOut'
            },
            {
                name: i18n.global.t("['100～200台']"),
                type: 'graph',
                layout: 'none',
                force: {
                    repulsion: 2500,
                    edgeLength: [10, 50]
                },
                label: {
                    show: true,
                    verticalAlign: 'middle',
                    align: 'center',
                    formatter: (val) => {
                        console.log(val)
                        return  [
                            val.data.product,
                            val.name,
                            val.value,
                        ].join('\n')
                    },
                    rich: {
                        a: {
                            fontSize: 12,
                            fontWeight: 400,
                            color: '#FFFFFF',
                        }, b: {
                            fontSize: 16,
                            fontWeight: 400,
                            color: '#FFFFFF',
                        }, c: {
                            fontSize: 12,
                            fontWeight: 400,
                            color: '#FFFFFF',
                        }
                    }
                },
                data: list2,
                animation: true,
                animationThreshold: 2000,
                animationDuration: 1000,
                animationEasing: 'cubicOut',
                animationDelay: 0,
                animationDurationUpdate: 300,
                animationEasingUpdate: 'cubicInOut'
            },
            {
                name: i18n.global.t("['小于100台']"),
                type: 'graph',
                layout: 'none',
                force: {
                    repulsion: 2500,
                    edgeLength: [10, 50]
                },
                label: {
                    show: true,
                    verticalAlign: 'middle',
                    align: 'center',
                    formatter: (val) => {
                        console.log(val)
                        return  [
                            val.data.product,
                            val.name,
                            val.value,
                        ].join('\n')
                    },
                    rich: {
                        a: {
                            fontSize: 12,
                            fontWeight: 400,
                            color: '#FFFFFF',
                        }, b: {
                            fontSize: 16,
                            fontWeight: 400,
                            color: '#FFFFFF',
                        }, c: {
                            fontSize: 12,
                            fontWeight: 400,
                            color: '#FFFFFF',
                        }
                    }
                },
                data: list3,
                animation: true,
                animationThreshold: 2000,
                animationDuration: 1000,
                animationEasing: 'cubicOut',
                animationDelay: 0,
                animationDurationUpdate: 300,
                animationEasingUpdate: 'cubicInOut'
            },
        ],
    };
    var listener = () => {
        myChart.resize()
    }
    EleResize.on(chartDom, listener)
    myChart.clear()
    myChart && option && myChart.setOption(option)
}
const hLineEcharts = (options) => {
    let { chartDom } = options;
    let myChart = chartDom && echarts.init(chartDom, null, { renderer: 'svg' });
    var data = [

        ["广东", 20],
        ["上海", 10],
        ["山东", 30],
        ["陕西", 15],
        ["福建", 18],
        ["广西", 17],
        ["海南", 20],
        ["重庆", 30],
        ["北京", 18],
    ]

    let option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            backgroundColor: 'rgba(60, 66, 84, 0.70)',
            borderWidth: 0,
            textStyle: {
                color: '#FFFFFF'
            }
        },
        legend: {
            show: false,
            data: ["M1"]
        },
        grid: {
            top: '5%',
            left: '3%',
            right: '4%',
            bottom: '10%',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            axisLabel: {
                color: '#B6B7BC'
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#B6B7BC33',
                    type: 'dashed',
                }
            },
        },
        yAxis: {
            type: 'category',
            inverse: true,
            axisLabel: {
                color: '#B6B7BC'
            },

        },
        dataset: {
            source: data
        },
        color: ['#11CABE'],
        series: [
            {
                name: "M1",
                type: 'bar',
                barWidth: "60%",
                stack: "y",
                label: {
                    show: false,

                    position: "right"
                },
            },

        ]
    };
    var listener = () => {
        myChart.resize()
    }
    EleResize.on(chartDom, listener)
    myChart.clear()
    myChart && option && myChart.setOption(option)
}
const chinaEcharts = (options) => {
    let { chartDom, dataList } = options;
    let myChart = chartDom && echarts.init(chartDom, null, { renderer: 'svg' });
    //各省份的地图json文件
    var provinces = {
        '上海': require('../assets/get/area/上海.json'),
        '河北': require('../assets/get/area/河北.json'),
        '山西': require('../assets/get/area/山西.json'),
        '内蒙古': require('../assets/get/area/内蒙古.json'),
        '辽宁': require('../assets/get/area/辽宁.json'),
        '吉林': require('../assets/get/area/吉林.json'),
        '黑龙江': require('../assets/get/area/黑龙江.json'),
        '江苏': require('../assets/get/area/江苏.json'),
        '浙江': require('../assets/get/area/浙江.json'),
        '安徽': require('../assets/get/area/安徽.json'),
        '福建': require('../assets/get/area/福建.json'),
        '江西': require('../assets/get/area/江西.json'),
        '山东': require('../assets/get/area/山东.json'),
        '河南': require('../assets/get/area/河南.json'),
        '湖北': require('../assets/get/area/湖北.json'),
        '湖南': require('../assets/get/area/湖南.json'),
        '广东': require('../assets/get/area/广东.json'),
        '广西': require('../assets/get/area/广西.json'),
        '海南': require('../assets/get/area/海南.json'),
        '四川': require('../assets/get/area/四川.json'),
        '贵州': require('../assets/get/area/贵州.json'),
        '云南': require('../assets/get/area/云南.json'),
        '西藏': require('../assets/get/area/西藏.json'),
        '陕西': require('../assets/get/area/陕西.json'),
        '甘肃': require('../assets/get/area/甘肃.json'),
        '青海': require('../assets/get/area/青海.json'),
        '宁夏': require('../assets/get/area/宁夏.json'),
        '新疆': require('../assets/get/area/新疆.json'),
        '北京': require('../assets/get/area/北京.json'),
        '天津': require('../assets/get/area/天津.json'),
        '重庆': require('../assets/get/area/重庆.json'),
        '香港': require('../assets/get/area/香港.json'),
        '澳门': require('../assets/get/area/澳门.json'),
    };

    //各省份的数据
    var allData = [{
        name: '北京',
        value: 21,
        address: [116.619862, 40.364355]

    }, {
        name: '天津',
        value: 22,
        address: [117.429343, 39.229049]

    }, {
        name: '上海',
        value: 23,
        address: [121.550338, 31.083525]

    }, {
        name: '重庆',
        value: 24,
        address: [106.685322, 29.422477]

    }, {
        name: '河北',
        value: 25,
        address: [115.589613, 38.480997]

    }, {
        name: '河南',
        value: 26,
        address: [113.823473, 33.951224]

    }, {
        name: '云南',
        value: 27,
        address: [101.313311, 24.276165]

    }, {
        name: '辽宁',
        value: 28,
        address: [123.022121, 41.31447]

    }, {
        name: '黑龙江',
        value: 29,
        address: [128.688489, 46.927354]

    }, {
        name: '湖南',
        value: 30,
        address: [111.836565, 27.733532]

    }, {
        name: '安徽',
        value: 40,
        address: [117.061397, 32.528926]

    }, {
        name: '山东',
        value: 50,
        address: [118.386003, 36.308797]

    }, {
        name: '新疆',
        value: 60,
        address: [85.344457, 41.1478]

    }, {
        name: '江苏',
        value: 70,
        address: [119.416251, 33.582446]

    }, {
        name: '浙江',
        value: 80,
        address: [120.152143, 29.099817]

    }, {
        name: '江西',
        value: 10,
        address: [115.663203, 27.798996]

    }, {
        name: '湖北',
        value: 11,
        address: [112.425278, 31.146842]

    }, {
        name: '广西',
        value: 12,
        address: [109.040176, 23.66755]

    }, {
        name: '甘肃',
        value: 13,
        address: [96.346041, 40.388978]

    }, {
        name: '山西',
        value: 14,
        address: [112.351689, 37.783466]

    }, {
        name: '内蒙古',
        value: 15,
        address: [118.60677, 44.293946]
    }, {
        name: '陕西',
        value: 16,
        address: [109.5553, 35.65083]

    }, {
        name: '吉林',
        value: 17,
        address: [126.77517, 43.334769]

    }, {
        name: '福建',
        value: 18,
        address: [118.018057, 25.884648]

    }, {
        name: '贵州',
        value: 19,
        address: [106.906089, 26.878914]

    }, {
        name: '广东',
        value: 31,
        address: [113.602705, 23.803048]

    }, {
        name: '青海',
        value: 32,
        address: [96.309246, 35.830824]

    }, {
        name: '西藏',
        value: 33,
        address: [87.699311, 31.525843]

    }, {
        name: '四川',
        value: 34,
        address: [103.079452, 30.38424]

    }, {
        name: '宁夏',
        value: 35,
        address: [106.464554, 37.373475]

    }, {
        name: '海南',
        value: 36,
        address: [109.702478, 18.910196]

    }, {
        name: '台湾',
        value: 37,
        address: [120.961624, 23.870744]

    }, {
        name: '香港',
        value: 38,
        address: [114.18222, 22.281304]

    }, {
        name: '澳门',
        value: 44,
        address: [113.559012, 22.139967]

    }];


    var convertData = function (data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
            // var geoCoord = provinces[data[i].name] && provinces[data[i].name]['features'] && provinces[data[i].name]['features'][0]['properties']['center'];
            var geoCoord = data[i].address
            if (geoCoord) {
                res.push({
                    name: data[i].name,
                    value: geoCoord.concat(data[i].value),
                });
            }
        }
        return res;
    };

    loadMap(zhanjiangMP, 'china');//初始化全国地图

    var timeFn = null;

    //单击切换到省级地图，当mapCode有值,说明可以切换到下级地图
    myChart.on('click', function (params) {
        clearTimeout(timeFn);
        //由于单击事件和双击事件冲突，故单击的响应事件延迟250毫秒执行
        timeFn = setTimeout(function () {
            var name = params.name; //地区name
            var mapCode = provinces[name]; //地区的json数据
            console.log(mapCode)
            if (!mapCode) {
                alert('无此区域地图显示');
                return;
            }
            loadMap(mapCode, name);
        }, 250);
    });


    // 绑定双击事件，返回全国地图
    myChart.on('dblclick', function () {
        //当双击事件发生时，清除单击事件，仅响应双击事件
        clearTimeout(timeFn);

        //返回全国地图
        loadMap(zhanjiangMP, 'china');
    });

    /**
     获取对应的json地图数据，然后向echarts注册该区域的地图，最后加载地图信息
     @params {String} mapCode:json数据的地址
     @params {String} name: 地图名称
     */
    // var vbgPatternImg = new Image();
    // vbgPatternImg.src = './廓形.png';
    function loadMap(mapCode, name) {
        var mapList = []
        allData && allData.map(item => {
            for (let i in dataList && dataList['map']) {
                console.log(i)
                if (name == 'china') {
                    if (i.includes(item.name)) {
                        mapList.push(item)
                    }
                } else {
                    if (i.includes(name)) {
                        mapList.push(item)
                    }
                }
            }

        })
        mapList = convertData(mapList)
        echarts.registerMap(name, mapCode);
        var option = {
            // backgroundColor: {
            //     image: vbgPatternImg,
            //     repeat: 'repeat',
            // },
            // graphic: [
            //     {
            //         type: 'image', // 图形元素类型
            //         id: 'logo', // 更新或删除图形元素时指定更新哪个图形元素，如果不需要用可以忽略。
            //         left: 'center', // 根据父元素进行定位 （居中）
            //         bottom: '0%', // 根据父元素进行定位   （0%）, 如果bottom的值是 0，也可以删除该bottom属性值。
            //         z: 0,  // 层叠
            //         bounding: 'all', // 决定此图形元素在定位时，对自身的包围盒计算方式
            //         style: {
            //             image: './廓形.png', // 这里一定要注意、注意，必须是https开头的图片路径地址
            //             width: 970,
            //             height:760
            //         }
            //     }
            // ],
            tooltip: {
                show: true,
                padding: 0,
                position: function (point) {
                    // 固定在顶部
                    return [point[0] - 30, point[1] - 162];
                },
                backgroundColor: '#FFFFFF00',
                borderColor: '#FFFFFF00',
                renderMode: 'html',
                formatter: function (params) {
                    var mapData = ''
                    for (let i in dataList && dataList['map']) {
                        if (i.includes(params.name)) {
                            mapData = dataList && dataList['map'][i]
                        }
                    }
                    if (params.data && mapData) return `<div style='width:0px;height:0px;background: :#FFFFFF00;border:none' class='position-relative'>
                    <img class='position-absolute' style='top:0;left:0px;width:227px;height:192px;' src=${require('./dasd.png')} />
                    <div class='position-absolute' style='top:15px;left:20px;color:#FFFFFF'>
                        <div class='ms-2 fs-20 mb-1'>${params.name}</div>
                        <div style='width:170px' class='ms-2 d-flex justify-content-between'>
                        <div  class='d-flex align-items-center fs-15'><div style='width:9px;height:9px;margin-right:10px;border-radius: 9px;background: linear-gradient(210deg, #59EDC9 0%, #2DAF91 53.65%, #1D9275 93.75%);box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);'></div>
                        已绑定：</div>
                        <div> ${mapData['已绑定']}台</div>
                        </div>
                        <div style='width:170px' class='ms-2 d-flex justify-content-between'>
                        <div  class='d-flex align-items-center fs-15'><div style='width:9px;height:9px;margin-right:10px;border-radius: 9px;background:#EDDD81;box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);'></div>
                        未绑定：</div>
                        <div> ${mapData['未绑定']}台</div>
                        </div>
                        <div style='width:170px' class='ms-2 d-flex justify-content-between'>
                        <div  class='d-flex align-items-center fs-15'><div style='width:9px;height:9px;margin-right:10px;border-radius: 9px;background:#54C0DF;box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);'></div>
                        报废：</div>
                        <div> ${mapData['报废']}台</div>
                        </div>
                        <div style='width:170px' class='ms-2 d-flex justify-content-between'>
                        <div  class='d-flex align-items-center fs-15'><div style='width:9px;height:9px;margin-right:10px;border-radius: 9px;background:#59EDC9;box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);'></div>
                        进行中工单总量：</div>
                        <div> ${mapData['进行中工单总量']}个</div>
                        </div>
                        <div style='width:170px' class='ms-2 d-flex justify-content-between'>
                        <div  class='d-flex align-items-center fs-15'><div style='width:9px;height:9px;margin-right:10px;border-radius: 9px;background:#B156E5;box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);'></div>
                        客户总量：</div>
                        <div> ${mapData['客户总量']}个</div>
                        </div>
                    </div>
                    </div>`
                },
            },
            geo: [
                {
                    // 主图
                    map: name,
                    zlevel: 0,
                    zoom: 1.02, //当前视角的缩放比例
                    roam: false, //是否开启平游或缩放
                    center: undefined,
                    show: true,
                    hoverAnimation: false,
                    label: {
                        normal: {
                            show: false,
                        },
                        emphasis: {
                            show: false,
                        },
                    },
                    itemStyle: {
                        normal: {
                            borderColor: "rgba(141, 199, 255,1)",
                            borderWidth: 1,
                            areaColor: '#218CD91A',
                        },
                        emphasis: {
                            areaColor: "#2d9eff", //悬浮区背景
                            shadowColor: "rgba(20, 113, 255,1)",
                            shadowOffsetX: -2,
                            shadowOffsetY: 5,
                            shadowBlur: 10,
                        },
                    },
                },
                //第一层投影
                {
                    map: name,
                    zlevel: -1,
                    zoom: 1.04, //当前视角的缩放比例
                    roam: false, //是否开启平游或缩放
                    center: undefined,
                    hoverAnimation: false,
                    show: true,
                    label: {
                        normal: {
                            show: false,
                        },
                        emphasis: {
                            show: false,
                        },
                    },
                    itemStyle: {
                        normal: {
                            borderJoin: "round",
                            borderColor: "rgba(176,228,252,1)",
                            borderWidth: 3,
                            areaColor: "rgba(133,188,232,1)",
                            shadowColor: "rgba(133,188,232,.7)",
                            shadowOffsetX: 0,
                            shadowOffsetY: 0,
                            shadowBlur: 25,
                        },
                        emphasis: {
                            show: false,
                        },
                    },
                },
                // 第二层投影
                {
                    map: name,
                    zlevel: -2,
                    zoom: 1.06, //当前视角的缩放比例
                    roam: false, //是否开启平游或缩放
                    center: undefined,
                    hoverAnimation: false,
                    show: true,
                    label: {
                        normal: {
                            show: false,
                        },
                        emphasis: {
                            show: false,
                        },
                    },
                    itemStyle: {
                        normal: {
                            borderJoin: "round",
                            areaColor: "rgba(30,49,105,1)",
                            shadowColor: "rgba(30,49,105,1)",
                            shadowOffsetX: -5,
                            shadowOffsetY: 6,
                        },
                        emphasis: {
                            show: false,
                        },
                    },
                }

            ],
            grid: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
            },
            series: [
                {
                    name: 'MAP',
                    type: 'map',
                    mapType: name,
                    hoverAnimation: false,
                    layoutSize: '110%', //地图的大小
                    selectedMode: 'false',//是否允许选中多个区域
                    label: {
                        normal: {
                            show: false,//是否显示标签
                            textStyle: {
                                color: '#fff',
                            },
                        },
                        emphasis: {
                            textStyle: {
                                color: '#fff',
                            },
                        },
                    },
                    //地图区域的多边形 图形样式
                    itemStyle: {
                        normal: {
                            borderColor: '#2ab8ff',
                            borderWidth: 2,
                            areaColor: '#12235c',
                        },
                        emphasis: {
                            areaColor: '#2AB8FF',
                            borderWidth: 0,
                        },
                    },
                    data: allData,
                    // markPoint: {
                    //     symbol: 'image://' + require('../assets/images/dashboard/locationPinned.png'),
                    //     data: [{ valueIndex: 3}],
                    //     symbolOffset: [17, -23],
                    //     zlevel: 3,
                    //     label: {
                    //         position: ['35%', '20%'],
                    //         color: '#ffffff'
                    //     }
                    // },
                }, {
                    name: '点',
                    type: 'scatter',
                    coordinateSystem: 'geo',
                    symbolSize: 35,
                    label: {
                        normal: {
                            show: true,
                            offset: [0, -20],
                            formatter: function (value) {
                                return value.value[2];
                            },
                            textStyle: {
                                color: '#fff',
                                fontSize: 13,
                                fontWeight: 600
                            },
                        },
                    },
                    symbol: 'image://' + require('../assets/images/dashboard/locationPinned.png'),
                    itemStyle: {
                        normal: {
                            color: '#F77474', //标志颜色
                        },
                    },
                    zlevel: 6,
                    data: mapList,
                },
                // 柱状体的顶部
                // {
                //     type: 'scatter',
                //     coordinateSystem: 'geo',
                //     geoIndex: 0,
                //     zlevel: 5,
                //     label: {
                //       show: true,
                //       formatter: function () {
                //         return `顶部label`
                //       },
                //       position: "top"
                //     },
                //     symbol: 'circle',
                //     symbolSize: [20, 10],
                //     itemStyle: {
                //       color: 'rgb(22,255,255, 1)',
                //       opacity: 1
                //     },
                //     silent: true,
                //     data: mapList
                //   },
                //   // 柱状体的底部

            ]
        };
        myChart && option && myChart.setOption(option);
        // curMap = {
        //     mapCode: mapCode,
        //     mapName: name
        // };
    }
    var listener = () => {
        myChart.resize()
    }
    EleResize.on(chartDom, listener)
}
const tendencyEcharts = (options) => {
    let { chartDom,type } = options;
    let myChart = chartDom && echarts.init(chartDom, null, { renderer: 'svg' });
    let option = {
        //         tooltip:{
        //             trigger: "axis",
        //             backgroundColor: 'rgba(50,50,50,0)',
        // borderWidth: 1 ,
        //                     axisPointer: {
        //                       type: "none"
        //                     },
        //                     formatter: () => {
        //                         return `<div class='d-flex'><div style='color:#ffffff;font-size:16'>400台</div><div style='color:#F77474;font-size:14'>+12%</div></div><div style='color:#B6B7BC;font-size:12'>2022年增长率</div> `;
        //                     },
        //           },
        xAxis: {
            type: 'category',
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],

            splitLine: {//分割线配置
                show: false,
            },
            axisLine: {
                show: false
            },
            axisLabel: {
                show: false,
            },
            axisTick: {
                show: false,
            },
        },
        yAxis: {
            type: 'value',

            splitLine: {//分割线配置
                show: false,
            },
            axisLine: {
                show: false
            },
            axisLabel: {
                show: false,
            }
        },
        grid: {
            left: 0,
            right: 0,
            top: '5%',
            bottom: '20%',
        },
        series: [

            {
                data: [82, 43, 70, 93, 52, 133, 132],
                type: 'line',
                smooth: true,
                showSymbol: false,
                markPoint: {
                    symbol: 'circle',
                    symbolSize: 1,
                    data: [{
                        name: '某个坐标',
                        coord: [0, 82],
                        itemStyle: {
                            color: '#8371F2',
                            borderColor: '#8371F2',
                            borderWidth: 1,
                        }
                    }, {
                        name: '某个坐标',
                        coord: [1, 43],
                        itemStyle: {
                            color: '#8371F2',
                            borderColor: '#8371F2',
                            borderWidth: 1,
                        }
                    }, {
                        name: '某个坐标',
                        coord: [2, 70],
                        itemStyle: {
                            color: '#8371F2',
                            borderColor: '#8371F2',
                            borderWidth: 1,
                        }
                    }, {
                        name: '某个坐标',
                        coord: [3, 93],
                        itemStyle: {
                            color: '#8371F2',
                            borderColor: '#8371F2',
                            borderWidth: 1,
                        }
                    }, {
                        name: '某个坐标',
                        coord: [4, 52],
                        itemStyle: {
                            color: '#8371F2',
                            borderColor: '#8371F2',
                            borderWidth: 1,
                        }
                    }, {
                        name: '某个坐标',
                        coord: [5, 133],
                        itemStyle: {
                            color: '#8371F2',
                            borderColor: '#8371F2',
                            borderWidth: 1,
                        }
                    }, {
                        name: '某个坐标',
                        coord: [6, 132],
                        itemStyle: {
                            color: '#8371F2',
                            borderColor: '#8371F2',
                            borderWidth: 1,
                        }
                    }],
                    emphasis: {
                        itemStyle: {
                            color: '#8371F2',
                            borderColor: '#8371F2',
                            borderWidth: 1,
                        },
                        label: {

                            formatter: () => {

                                return `{a|400台}  {b|+12%}\n{c|2022年增长率}`;
                            },
                            offset: [-40, -15],
                            rich: {
                                a: {
                                    color: '#ffffff',
                                    fontSzie: 16
                                }, b: {
                                    color: '#11CABE',
                                    fontSzie: 14
                                }, c: {
                                    color: '#B6B7BC',
                                    fontSzie: 12
                                },
                            },

                        },
                    }
                },
                lineStyle: {
                    color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                        {
                            offset: 0,
                            color: '#C0B8F5',
                        },
                        {
                            offset: 0.5,
                            color: '#8371F2',
                        },
                        {
                            offset: 1,
                            color: '#8371F2',
                        },
                    ]),
                    shadowColor: '#8371F2',//设置折线阴影
                    shadowBlur: 2,
                    shadowOffsetY: 5,
                },
            }, type=='0'?{
                data: [62, 23, 30, 43, 22, 73, 82],
                type: 'line',
                smooth: true,
                showSymbol: false,
                markPoint: {
                    symbol: 'circle',
                    symbolSize: 1,
                    data: [{
                        name: '某个坐标',
                        coord: [0, 62],
                        color: '#8371F2',
                        borderColor: '#8371F2',
                        borderWidth: 1,
                    }, {
                        name: '某个坐标',
                        coord: [1, 23],
                        color: '#8371F2',
                        borderColor: '#8371F2',
                        borderWidth: 1,
                    }, {
                        name: '某个坐标',
                        coord: [2, 30],
                        color: '#8371F2',
                        borderColor: '#8371F2',
                        borderWidth: 1,
                    }, {
                        name: '某个坐标',
                        coord: [3, 43],
                        color: '#8371F2',
                        borderColor: '#8371F2',
                        borderWidth: 1,
                    }, {
                        name: '某个坐标',
                        coord: [4, 22],
                        color: '#8371F2',
                        borderColor: '#8371F2',
                        borderWidth: 1,
                    }, {
                        name: '某个坐标',
                        coord: [5, 73],
                        color: '#8371F2',
                        borderColor: '#8371F2',
                        borderWidth: 1,
                    }, {
                        name: '某个坐标',
                        coord: [6, 82],
                        color: '#8371F2',
                        borderColor: '#8371F2',
                        borderWidth: 1,
                    }],
                    emphasis: {
                        itemStyle: {
                            color: '#14ACC1',
                            borderColor: '#14ACC1',
                            borderWidth: 1,
                        },
                        label: {
                            formatter: () => {
                                return `{a|400台}  {b|-12%}\n{c|2022年报废率}`;
                            },
                            offset: [-40, 15],
                            rich: {
                                a: {
                                    color: '#ffffff',
                                    fontSzie: 16
                                }, b: {
                                    color: '#F77474',
                                    fontSzie: 14
                                }, c: {
                                    color: '#B6B7BC',
                                    fontSzie: 12
                                },
                            },

                        },
                    }
                },
                lineStyle: {
                    color: '#14ACC1',
                    shadowColor: '#14ACC1',//设置折线阴影
                    shadowBlur: 2,
                    shadowOffsetY: 5,
                },
            }:{},

        ]
    };
    myChart && option && myChart.setOption(option);
    // curMap = {
    //     mapCode: mapCode,
    //     mapName: name
    // };
    var listener = () => {
        myChart.resize()
    }
    EleResize.on(chartDom, listener)
}
const lineEchart = (options) => {
    let { chartDom ,unit,
        monthList,
        list1,
        list2,
        list3,
        name1,
        name2,
        name3,
    } = options;
    let myChart = chartDom && echarts.init(chartDom, null, { renderer: 'svg' });
    var pattern2 = new RegExp("[A-Za-z]+")
    var normalColor = "rgba(255,255,255,.5)";
    let option = {

        title: {
            textStyle: {
                fontSize: 14
            }
        },
        legend: {
            itemGap: 5,
            icon: 'circle',
            itemWidth: 8, // 设置宽度
            itemHeight: 8,
            top: '0',
            left:pattern2.test(name1)?'center':'center' ,
            textStyle: {
                color: '#ffffff'
            },
            data: [name1,name2,name3]
        },
        tooltip: { // 提示框组件
            trigger: 'axis',
            show: true,
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
                type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            },
            valueFormatter: (value, name) => {
                console.log(value, name)
               return value&&Number(value)
            },
            backgroundColor: 'rgba(60, 66, 84, 0.70)',
            borderWidth: 0,
            textStyle: {
                color: '#FFFFFF'
            },
            padding: 10,
        
        },
        grid: {
            left: '10%',
            right: '10%',
            top: '17%',
            bottom: '13%',
        },
        xAxis: [{
            type: 'category',
            boundaryGap: true, // 坐标轴两边留白
            
            axisLabel: {
                color: normalColor,
                fontSize: 15,
            },
            axisTick: {
                show: false
            },
            axisLine: {
                show: false,
                lineStyle: {
                    color: normalColor,
                }
            },
            splitLine: {
                show: false,
                lineStyle: {
                    type: "solid",
                    color: normalColor
                }
            },
            data: monthList
        }],
        yAxis: [{
            name: unit,
            nameTextStyle: {
                fontSize: 15,
            },
            type: 'value',
            axisLine: {
                show: false,
                lineStyle: {
                    color: normalColor,
                }
            },
            axisTick: {
                show: false,
            },
            axisLabel: {
                color: normalColor,
                fontSize: 15,
                // margin: 25,
                formatter: '{value}'
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#B6B7BC33',
                    type: 'dashed',
                }
            },
        }],
        series: [{
            name: name1,
            type: 'bar',
            yAxisIndex: 0,
            stack: '1',
            zlevel: 2,
            barGap: '50%',
            barWidth: '30%',
            barCategoryGap: "50%",
            color: normalColor,
            itemStyle: {
                normal: {
                    color: '#11CABE',
                    label: {
                        show: false,
                    }
                }
            },
            data: list1
        },
        {
            name: name2,
            type: 'bar',
            yAxisIndex: 0,
            stack: '1',
            zlevel: 2,
            barGap: '50%',
            barWidth: '30%',
            barCategoryGap: "50%",
            color: normalColor,
            itemStyle: {
                normal: {
                    color: '#246CF9',
                    borderRadius: [5, 5, 0, 0],
                    label: {
                        show: false,
                    }
                }
            },
            data: list2
            },
        {
            name: name3,
            type: 'line',
            yAxisIndex: 0,
            zlevel: 2,
            smooth: true,
            symbol: 'none',
            lineStyle: {
                width: 3
            },
            itemStyle: {
                normal: {
                    color: '#8371F2',

                }
            },
            data: list3
        },
       
        ]
    };
    myChart && option && myChart.setOption(option);
    // curMap = {
    //     mapCode: mapCode,
    //     mapName: name
    // };
    var listener = () => {
        myChart.resize()
    }
    EleResize.on(chartDom, listener)
}
const lineEchartIot = (options) => {
    let { chartDom ,unit,
        monthList,
        list1,
        list2,
        list3,
        list4,
        name1,
        name2,
        name3,
        name4
    } = options;
    let myChart = chartDom && echarts.init(chartDom, null, { renderer: 'svg' });
    var pattern2 = new RegExp("[A-Za-z]+")
    var normalColor = "rgba(255,255,255,.5)";
    let option = {

        title: {
            textStyle: {
                fontSize: 14
            }
        },
        legend: {
            itemGap: 5,
            icon: 'circle',
            itemWidth: 8, // 设置宽度
            itemHeight: 8,
            top: '0',
            left:pattern2.test(name1)?'center':'center' ,
            textStyle: {
                color: '#ffffff'
            },
            data: [name1,name2,name3,name4]
        },
        tooltip: { // 提示框组件
            trigger: 'axis',
            show: true,
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
                type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            },
            valueFormatter: (value, name) => {
                console.log(value, name)
               return value&&Number(value)
            },
            backgroundColor: 'rgba(60, 66, 84, 0.70)',
            borderWidth: 0,
            textStyle: {
                color: '#FFFFFF'
            },
            padding: 10,
        
        },
        grid: {
            left: '10%',
            right: '10%',
            top: '17%',
            bottom: '13%',
        },
        xAxis: [{
            type: 'category',
            boundaryGap: true, // 坐标轴两边留白
            
            axisLabel: {
                color: normalColor,
                fontSize: 15,
            },
            axisTick: {
                show: false
            },
            axisLine: {
                show: false,
                lineStyle: {
                    color: normalColor,
                }
            },
            splitLine: {
                show: false,
                lineStyle: {
                    type: "solid",
                    color: normalColor
                }
            },
            data: monthList
        }],
        yAxis: [{
            name: unit,
            nameTextStyle: {
                fontSize: 15,
            },
            type: 'value',
            axisLine: {
                show: false,
                lineStyle: {
                    color: normalColor,
                }
            },
            axisTick: {
                show: false,
            },
            axisLabel: {
                color: normalColor,
                fontSize: 15,
                // margin: 25,
                formatter: '{value}'
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#B6B7BC33',
                    type: 'dashed',
                }
            },
        },
        {
            name: '%',
            min:0,
            max:100,
            nameTextStyle: {
                fontSize: 15,
            },
            type: 'value',
            axisLine: {
                show: false,
                lineStyle: {
                    color: normalColor,
                }
            },
            axisTick: {
                show: false,
            },
            axisLabel: {
                color: normalColor,
                fontSize: 15,
                // margin: 25,
                formatter: '{value}'
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#B6B7BC33',
                    type: 'dashed',
                }
            },
        }],
        series: [{
            name: name1,
            type: 'bar',
            yAxisIndex: 0,
            stack: '1',
            zlevel: 2,
            barGap: '50%',
            barWidth: '30%',
            barCategoryGap: "50%",
            color: normalColor,
            itemStyle: {
                normal: {
                    color: '#11CABE',
                    label: {
                        show: false,
                    }
                }
            },
            data: list1
        },
        {
            name: name2,
            type: 'bar',
            yAxisIndex: 0,
            stack: '1',
            zlevel: 2,
            barGap: '50%',
            barWidth: '30%',
            barCategoryGap: "50%",
            color: normalColor,
            itemStyle: {
                normal: {
                    color: '#246CF9',
                    borderRadius: [5, 5, 0, 0],
                    label: {
                        show: false,
                    }
                }
            },
            data: list2
            },
            {
                name: name3,
            type: 'line',
            yAxisIndex: 1,
            zlevel: 2,
            smooth: true,
            symbol: 'none',
            lineStyle: {
                width: 3
            },
            itemStyle: {
                normal: {
                    color: '#14ACC1',

                }
            },
                data: list3
            },
        {
            name: name4,
            type: 'line',
            yAxisIndex: 0,
            zlevel: 2,
            smooth: true,
            symbol: 'none',
            lineStyle: {
                width: 3
            },
            itemStyle: {
                normal: {
                    color: '#8371F2',

                }
            },
            data: list4
        },
       
        ]
    };
    myChart && option && myChart.setOption(option);
    // curMap = {
    //     mapCode: mapCode,
    //     mapName: name
    // };
    var listener = () => {
        myChart.resize()
    }
    EleResize.on(chartDom, listener)
}
export {
    deviceBindingStatisticsEcharts,
    deviceTypeStatisticsEcharts,
    industryStatisticsEcharts,
    deviceStatusEcharts,
    industryStatisticsBarEcharts,
    hLineEcharts,
    chinaEcharts,
    tendencyEcharts,
    lineEchart,
    lineEchartIot
}